import { FunctionComponent } from "react";
import styled from "styled-components";
import theme from "../theme";

interface Props {
  size?: "small";
}
const Input = styled.input<Props>`
  height: 36px;
  width: ${(props) =>
    props.size === "small" ? `${theme.unit * 8}px` : "100%"};
  margin-bottom: ${theme.unit * 2}px;
  border: 1px solid ${theme.colors.grey};
  padding: 0 ${theme.unit}px;
  padding: 0 ${theme.unit / 2}px;
  font-size: 16px;
`;

const Wrapper: FunctionComponent<any> = (props) => {
  return (
    <Input {...props} {...props.input}>
      {props.children}
    </Input>
  );
};

export default Wrapper;
